//  --------------------------------------------------------
//  GoToUrl
//  --------------------------------------------------------

const goToUrl = (newLocation) => {
    window.location = newLocation;
};

module.exports = goToUrl;



// WEBPACK FOOTER //
// ./___src/assets/js/lib/goToUrl.js